import { render, staticRenderFns } from "./pricehelp.vue?vue&type=template&id=791068fc&"
import script from "./pricehelp.vue?vue&type=script&lang=js&"
export * from "./pricehelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('791068fc')) {
      api.createRecord('791068fc', component.options)
    } else {
      api.reload('791068fc', component.options)
    }
    module.hot.accept("./pricehelp.vue?vue&type=template&id=791068fc&", function () {
      api.rerender('791068fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-8iB4P35ZhSPWp/JS/pricehelp.vue"
export default component.exports